import { h, render } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unresolved
import SwiperCore, { Pagination } from 'swiper/core';
import Image from '../utils/image';
import OrangeStar from '../utils/icons/star-orange.svg';

SwiperCore.use([Pagination]);

export default (element, data) => {
  const LifesharpTestimonials = () => {
    const swiperPagination = {
      el: `#${data?.id} #testimonials_swiper_nav`,
      clickable: true,
      type: 'bullets',
    };

    return (
      data && (
        <div className="flex flex-col laptop:flex-row">
          <div className="w-full laptop:w-1/2 overflow-hidden">
            <Image
              src={data.image}
              className="w-full desktop:h-full object-cover aspect-[335/258] laptop:aspect-[680/524]"
              alt={data.imageAltText || 'knife'}
              srcWidths={{
                sm: 800,
                md: 900,
                lg: 1200,
                xl: 1400,
                '2xl': 1800,
              }}
            />
          </div>

          <div className="w-full laptop:flex laptop:items-center laptop:w-1/2 py-8 laptop:py-0 laptop:pl-10 desktop:pl-14 relative">
            <div className="w-full">
              <Swiper
                slidesPerView={1}
                modules={Pagination}
                pagination={swiperPagination}
              >
                {data.testimonials &&
                  data.testimonials.map((testimonial) => (
                    <SwiperSlide key={testimonial.id}>
                      <article className="laptop:flex">
                        <h2 class="sr-only">
                          customer testimonial from {testimonial.name}
                        </h2>

                        <div className="w-full mb-8 laptop:mb-0">
                          <div className="w-32 flex gap-[5px] justify-between mb-3 laptop:mb-5">
                            <OrangeStar className="w-5" />
                            <OrangeStar className="w-5" />
                            <OrangeStar className="w-5" />
                            <OrangeStar className="w-5" />
                            <OrangeStar className="w-5" />
                          </div>

                          <p
                            className="mb-3 laptop:mb-5
                              subheading-1
                              text-lg
                              laptop:text-xl
                              leading-6
                              desktop:text-3xl
                              desktop:leading-10
                              before:content-[open-quote]
                              after:content-[close-quote]
                            "
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                              __html: testimonial.testimonial,
                            }}
                          />

                          <div class="flex flex-col laptop:flex-row laptop:gap-5">
                            <div className="flex gap-3 laptop:gap-5 mb-3 laptop:mb-0 laptop:items-center">
                              <p className="font-m-16 desktop:text-lg">
                                {testimonial.name}
                              </p>

                              <p
                                className="font-m-16 desktop:text-lg"
                                style={`color: ${
                                  testimonial.verified_customer_color ||
                                  'initial'
                                }`}
                              >
                                {data.verifiedCustomer}
                              </p>

                              <p className="hidden laptop:block font-m-16 desktop:text-lg">
                                {testimonial.date}
                              </p>
                            </div>

                            <p className="laptop:hidden font-m-16">
                              {testimonial.date}
                            </p>
                          </div>
                        </div>
                      </article>
                    </SwiperSlide>
                  ))}
              </Swiper>
              <div
                id="testimonials_swiper_nav"
                className="flex
                  first:[&_.swiper-pagination-bullet]:ml-0
                  after:[&_.swiper-pagination-bullet]:bg-grey-400
                  after:[&_.swiper-pagination-bullet-active]:bg-secondary-2
                  after:[&_.swiper-pagination-bullet]:bottom-0
                  [&_.swiper-pagination-bullet]:opacity-100
                  [&_.swiper-pagination-bullet]:h-[14px]
                "
              />
            </div>
          </div>
        </div>
      )
    );
  };

  render(<LifesharpTestimonials />, element);
};
